import {
  clearSessionStorage,
  clearStorage,
  SessionStorageKey,
} from "@/constants/storage";

export const reloadWebsite = () => {
  clearStorage(undefined, { includeUnmanaged: true });
  clearSessionStorage([SessionStorageKey.SENTRY_REPLAY_SESSION], {
    mode: "keep",
    includeUnmanaged: true,
  });

  window.open("/", "_self");
};
